<template>
  <CHeader position="fixed" class="mb-2 fixed-top wrapper"
           style="z-index: 1029 !important;">
    <CContainer fluid>
      <CHeaderToggler class="ps-1" @click="$store.commit('toggleUnfoldable')">
        <font-awesome-icon :icon="['fas', 'bars']" />
      </CHeaderToggler>
<!--      <a href="https://trophylab.com/" target="_blank"><img class="d-block" width="35" height="35" :src="trophylab_symbol" /></a>-->
<!--      <div class="px-2 sidebar-brand-full">-->
<!--        <a href="https://trophylab.com/" target="_blank" class="text-black text-decoration-none">TrophyLab.com</a>-->
<!--      </div>-->
      <CHeaderNav class="d-none d-md-flex me-auto">
        <CNavItem v-for="(item,index) in bookmarkItems" :key="index">
          <CNavLink class="text-primary fw-bold" style="cursor: pointer" @click="routerPush(item.to)">{{item.name}}</CNavLink>
        </CNavItem>
        <CNavItem>
          <CInputGroup>
            <CFormInput class="ms-5" type="text" placeholder="모델명" v-model="this.productNm" @keyup.enter="this.searchProduct" />
            <CButton type="button" color="secondary" variant="outline" @click="this.searchProduct" ><font-awesome-icon :icon="['fas', 'magnifying-glass']" size="xl" /></CButton>
          </CInputGroup>
        </CNavItem>
      </CHeaderNav>

      <CHeaderNav>
        <CNavItem class="my-auto">
          <CNavLink><b class="text-success fw-bold">{{ this.$store.state.mbrInfo.mbrNm}}/{{ this.$store.state.mbrInfo.jbgdNm}}</b></CNavLink>
        </CNavItem>
        <CNavItem>
            <CButton class="nav-link position-relative" @click="viewMessage" >
            <font-awesome-icon :icon="['far', 'bell']" size="xl" style="cursor: pointer" title="알림" class="text-black" />
            <CBadge color="danger" position="top-end" shape="rounded-pill" v-if="messageCnt > 0">{{messageCnt}}</CBadge>
            </CButton>
        </CNavItem>
        <CNavItem>
          <RouterLink class="nav-link" to="/info/myInfo">
            <font-awesome-icon :icon="['far', 'user']" size="xl" style="cursor: pointer" title="정보수정" class="ms-2 me-1 text-black" />
          </RouterLink>
        </CNavItem>
        <CNavItem>
          <CNavLink href="#" @click="logout" class="mx-2">
            <font-awesome-icon :icon="['fas', 'arrow-right-from-bracket']" size="xl" style="cursor: pointer" title="로그아웃" class="ms-2 me-1 text-black" />
          </CNavLink>
        </CNavItem>
      </CHeaderNav>
    </CContainer>

<!--    <CContainer fluid>-->
<!--      <CNav variant="pills" layout="fill" class="d-none d-md-flex me-auto">-->
<!--        <CNavItem-->
<!--          v-for="item in $store.state.menuNav"-->
<!--          :key="item">-->
<!--          <CNavLink-->
<!--            :active="(this.isActiveLinkGroup(item.items))"-->
<!--            @click="this.subItems = item.items;console.log(this.subItems)"-->
<!--          >{{item.name}}</CNavLink>-->
<!--        </CNavItem>-->
<!--      </CNav>-->
<!--    </CContainer>-->
<!--    <CContainer fluid>-->
<!--      <CNav variant="pills" layout="fill" class="d-none d-md-flex me-auto">-->
<!--        <CNavItem-->
<!--          v-for="subitem in this.subItems"-->
<!--          :key="subitem">-->
<!--          <CNavLink-->
<!--            :active="(this.isActiveLink(subitem.to))"-->
<!--          >-->
<!--            <RouterLink :to="subitem.to">{{subitem.name}}</RouterLink>-->
<!--          </CNavLink>-->
<!--        </CNavItem>-->
<!--      </CNav>-->
<!--    </CContainer>-->
<!--    <CHeaderDivider />-->
<!--    <CContainer fluid>-->
<!--      <AppBreadcrumb />-->
<!--    </CContainer>-->
    <CToaster placement="middle-center">
      <template v-for="(item, index) in this.toasts" :key="index">
      <CToast :autohide="false" :visible="item.visible" :index="index" color="danger" class="border-2 border-danger">
        <CToastHeader closeButton :onClose="()=>{toastRouterClose(this.toasts, item, index);}">
          <span class="me-auto fw-bolder text-black" style="cursor: pointer" @click="toastRouterPush(this.toasts, item, index);">{{item.title}}</span>
          <small class="text-black">{{item.reqDt}}</small>
        </CToastHeader>
        <CToastBody style="cursor: pointer" @click="toastRouterPush(this.toasts, item, index);"><span class="fw-bold text-white" v-html="$filters.handleNewLine(item.body)" /></CToastBody>
      </CToast>
      </template>
    </CToaster>

    <CToaster placement="bottom-end" visible>
      <template v-for="(item, index) in this.toastsBottom" :key="index">
        <CToast :autohide="false" :visible="item.visible" :index="index" color="primary" class="border-2 border-dark" >
          <CToastHeader closeButton :onClose="()=>{toastRouterClose(this.toasts, item, index);}">
                <span class="me-auto fw-bolder text-black" style="cursor: pointer" @click="toastRouterPush(this.toasts, item, index);">{{item.title}}</span>
                <small class="text-black">{{item.reqDt}}</small>
            </CToastHeader>
            <CToastBody style="cursor: pointer" @click="toastRouterPush(this.toastsBottom, item, index);"><span class="fw-bold text-white" v-html="$filters.handleNewLine(item.body)" /></CToastBody>
        </CToast>
      </template>
    </CToaster>

    <COffcanvas placement="end" :backdrop="false" scroll :visible="visibleEnd" @hide="() => { visibleEnd = !visibleEnd }">
      <COffcanvasHeader>
        <COffcanvasTitle>Messages / Alerts</COffcanvasTitle>
        <CCloseButton class="text-reset" @click="() => { visibleEnd = false }"/>
      </COffcanvasHeader>
      <COffcanvasBody>

<!--        <CNav variant="tabs" class="flex-column flex-sm-row" role="tablist">-->
<!--          <CNavItem>-->
<!--            <CNavLink style="width: 100px;text-align: center" href="javascript:void(0);" :active="tabPaneActiveKey === 1" @click="() => {changeTabPaneActiveKey(1)}">-->
<!--              <b>받은 메시지</b></CNavLink>-->
<!--          </CNavItem>-->
<!--          <CNavItem>-->
<!--            <CNavLink style="width: 100px;text-align: center" href="javascript:void(0);" :active="tabPaneActiveKey === 2" @click="() => {changeTabPaneActiveKey(2)}">-->
<!--              <b>보낸 메시지</b></CNavLink>-->
<!--          </CNavItem>-->
<!--          <CNavItem>-->
<!--            <CNavLink style="width: 100px;text-align: center" href="javascript:void(0);" :active="tabPaneActiveKey === 3" @click="() => {changeTabPaneActiveKey(3)}">-->
<!--              <b>메시지 전송</b></CNavLink>-->
<!--          </CNavItem>-->
<!--        </CNav>-->
        <CTabContent>
          <CTabPane role="tabpanel" aria-labelledby="tab1" :visible="tabPaneActiveKey === 1 || tabPaneActiveKey === 2">
            <CRow v-if="pageMode == 'search'">
              <CInputGroup v-if="tabPaneActiveKey === 1">
                <CFormInput type="text" style="border-radius: 0px !important;" placeholder="보낸사람,내용" v-model="this.searchCn" @keyup.enter="this.getList(1)" />
                <CButton type="button" style="border-radius: 0px !important;" color="secondary" variant="outline" @click="this.getList(1)" ><font-awesome-icon :icon="['fas', 'magnifying-glass']" size="xl" /></CButton>
              </CInputGroup>
            </CRow>

            <CRow v-if="pageMode == 'search'">
              <CCol :xs="12">
              <CButton class="w-100" v-if="tabPaneActiveKey === 1 && this.messageCnt > 0"
                  type="button" style="border-radius: 0px !important;" color="primary" variant="outline" @click="this.updateAllRead" >
                <font-awesome-icon :icon="['fas', 'check']" size="xl" /> 모두 확인으로 표시
              </CButton>
              </CCol>
            </CRow>

            <CRow v-if="pageMode == 'search'">
            <ag-grid-vue
                style="width: 100%;"
                class="ag-theme-balham"
                readOnlyEdit="true"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefs"
                :rowData="listItems"
                @cell-clicked="this.onCellClicked"
                domLayout="autoHeight"
                :rowClass="'my-row-color1'"
                :enableBrowserTooltips="true"
                :getRowClass="(params)=>{if (params.node.rowIndex % 2 === 1) return 'my-row-color2'}"
            >
            </ag-grid-vue>

            <paginate
                v-model="this.page"
                :page-count="this.pageable.totalPages"
                :page-range="10"
                :margin-pages="0"
                :click-handler="this.getList"
                :prev-text="'＜'"
                :next-text="'＞'"
                :first-last-button=true
                :first-button-text="'≪'"
                :last-button-text="'≫'"
                :container-class="'pagination justify-content-center'"
                :page-class="'page-item'"
                style="margin-top:20px;"
            >
            </paginate>

            </CRow>
            <CRow v-if="pageMode == 'detail'">
              <CCol>
                  <CTable align="middle" bordered>
                    <colgroup>
                      <col width="25%" />
                      <col width="75%" />
                    </colgroup>
                  <CTableBody>
                    <CTableRow>
                      <CTableHeaderCell  color="secondary">보낸사람</CTableHeaderCell>
                      <CTableDataCell>{{(submitData.alarmMbrSn != null)?submitData.alarmMbrNm:(submitData.custNm+(submitData.coNm=='')?'':'('+submitData.coNm+')')}}
                      </CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableHeaderCell  color="secondary">전송일시</CTableHeaderCell>
                      <CTableDataCell>{{this.$filters.getStrDateTime(submitData.alarmDt)}}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableHeaderCell  color="secondary">전송결과</CTableHeaderCell>
                      <CTableDataCell>{{this.getNotiRcptnYnNm(submitData.notiRcptnYn)}}</CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableHeaderCell  color="secondary">제목</CTableHeaderCell>
                      <CTableDataCell>{{submitData.sj}}
                      </CTableDataCell>
                    </CTableRow>
                    <CTableRow>
                      <CTableHeaderCell  color="secondary">링크</CTableHeaderCell>
                      <CTableDataCell style="cursor: pointer"
                                      @click="routerPush(($filters.nvl(submitData.ordNo,'') == '')?submitData.url:submitData.url+'/'+submitData.ordNo)">
                        {{($filters.nvl(submitData.ordNo,'') == '')?submitData.url:submitData.url+'/'+submitData.ordNo}}
                      </CTableDataCell>
                    </CTableRow>
                    <CTableRow style="height: 400px;">
                      <CTableDataCell colspan="2" class="align-top text-start">
                        <span v-html="$filters.handleNewLine(submitData.cn)"></span>
                      </CTableDataCell>
                    </CTableRow>
                  </CTableBody>
                </CTable>

                <div class="d-grid gap-2 d-md-flex justify-content-md-center p-2">
                  <CButton type="button" color="light" @click="getList();this.pageMode='search'">목록</CButton>
                </div>
              </CCol>
            </CRow>
          </CTabPane>
          <CTabPane role="tabpanel" aria-labelledby="tab1" :visible="tabPaneActiveKey === 3">
            <CRow class="mb-3" v-if="pageMode == 'save'">
              <CCol>
                <CTable align="middle" bordered>
                  <colgroup>
                    <col width="25%" />
                    <col width="75%" />
                  </colgroup>
                  <CTableBody>
                    <CTableRow >
                      <CTableHeaderCell  color="secondary">받는사람</CTableHeaderCell>
                      <CTableDataCell>
                        <CFormSelect v-model="this.submitData.mbrSn"
                                     @change="this.submitData.mbrSn = $event.target.value"
                        >
                            <option value="">-</option>
                            <option v-for="option in mgrListItems"
                                    :key="option.mbrSn"
                                    :value="option.mbrSn">{{option.deptNm}} {{option.mbrNm}} {{option.jbgdNm}}</option>
                        </CFormSelect>
                      </CTableDataCell>
                    </CTableRow>
                    <CTableRow >
                      <CTableDataCell colspan="2" class="align-top text-start">
                        <CFormTextarea rows="5" v-model="this.submitData.cn"></CFormTextarea>
                      </CTableDataCell>
                    </CTableRow>
                  </CTableBody>
                </CTable>
                <div class="d-grid gap-2 d-md-flex justify-content-end p-2">
                  <CButton type="button" color="primary" @click="this.saveForm()">보내기</CButton>
                </div>
              </CCol>
            </CRow>
          </CTabPane>
        </CTabContent>

      </COffcanvasBody>
    </COffcanvas>

  </CHeader>
</template>

<script>
// import AppBreadcrumb from './AppBreadcrumb'
// import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
// import trophylab_symbol from '@/assets/images/trophylab/trophylab_symbol-removebg.png'
// import * as icon from '@coreui/icons';
import store from "@/store";
import {useRoute} from "vue-router";

import { initializeApp } from "firebase/app";
import { getMessaging, onMessage  } from "firebase/messaging";
import admin_mbrMbrNotiSendHist from "@/api/mbr/admin_mbrMbrNotiSendHist";
import mbrMbrNotiSendHist from "@/api/mbr/admin_mbrMbrNotiSendHist";
import {fnToInt} from "@/common/commonScript";
import mgrInfoApi from "@/api/mgr/admin_mgrMgrInfo";
import mgrMgrInfoApi from "@/api/mgr/admin_mgrMgrInfo";

export default {
  name: 'AppHeader',
  components: {
  },
  data() {
    return {
      visibleEnd: false,
      route : useRoute(),
      subItems : [],
      productNm : '',
      moveCnt : 0,
      toasts : [],
      toastsBottom : [],
      messageCnt : 0,
      tabPaneActiveKey: 1,

      pageMode: "search",
      page : 1,
      pageSize : 20,
      orderKey : "a.alarm_dt",
      direction : "desc",
      searchCn : '',
      listItems: [],
      bookmarkItems : [
        {
          "name": "일정관리",
          "to": "/work/scheduleMng",
        },
        {
          "name": "주문접수",
          "to": "/order/manageOrd",
        }
      ],
      submitData: {},
      pageable : {
        totalElements : 0,
        totalPages : 1,
      },
      /* gird 관련 */
      defaultColDef: {
        resizable: true,	// colimn 사이즈 조정 여부
        editable: false,	// 수정가능 여부
        sortable: false,		// 정렬순서 변경 여부
        suppressSizeToFit: true,	// 사이즈 조정부분 더블클릭 시 data길이에 맞춤
        suppressRowHoverHighlight:true,
        initialWidth: 100,
      },
      columnDefs : [],
      mgrListItems:[],
    }
  },
  methods: {
    onCellClicked(params){
      this.submitData = this.listItems.filter(item => item.mbrNotiSn === params.data.mbrNotiSn)[0];
      this.pageMode = 'detail';
    },
    changeTabPaneActiveKey :function (key) {
      this.tabPaneActiveKey = key;
      switch (this.tabPaneActiveKey) {
        case 1 :
          this.getList(1);
          this.pageMode = 'search';
          break;
        case 2 :
          this.getList(1);
          this.pageMode = 'search';
          break;
        case 3 :
          this.clearData();
          this.pageMode = 'save';
          break;
        default:
          break;
      }

    },
    clearData: function(){
      this.submitData = {}
    },
    saveForm: function(){

    },
    routerPush:function(path){
      this.moveCnt++;
      this.$router.push({path: path, query: { '':this.moveCnt }})
    },
    toastRouterClose:function(list, item, index){
      // console.log('toastRouterClose',item);
      let formData = new FormData();
      formData.append('mbrNotiSn', item.mbrNotiSn);
      formData.append('notiRcptnYn', '3'); //결과성공 => 읽음
      admin_mbrMbrNotiSendHist.updateMbrNotiSendHistRead(formData)
        .then((response) => {
            if( response.data.statusCode == 1 ){
              list.splice(index, 1);
              this.messageCnt = (this.messageCnt <= 0)?0:this.messageCnt - 1;
            }
          }
        ).catch((error) => console.log(error))
    },
    toastRouterPush:function(list, item, index){
      let formData = new FormData();
      formData.append('mbrNotiSn', item.mbrNotiSn);
      formData.append('notiRcptnYn', '3'); //결과성공 => 읽음

      admin_mbrMbrNotiSendHist.updateMbrNotiSendHistRead(formData)
          .then((response) => {
                if( response.data.statusCode == 1 ){
                  list.splice(index, 1);
                  this.messageCnt = (this.messageCnt <= 0)?0:this.messageCnt - 1;
                  this.moveCnt++;
                  if(item.mclCd == 'MGMC0853') {
                    //급주문
                    if(item.ordNo == undefined || item.ordNo == null || item.ordNo == '') {
                      this.$router.push({path: item.link, query: { '':this.moveCnt }})
                    } else {
                      this.$router.push({path: item.link+'/'+ item.ordNo, query: { '':this.moveCnt }})
                    }
                  } else if(item.mclCd == 'MGMC0854') {
                    //휴가신청
                    this.$router.push({path: item.link, query: { '':this.moveCnt}})
                  } else if(item.mclCd == 'MGMC0855') {
                    //발주서신청
                    this.$router.push({path: item.link, query: { '':this.moveCnt}})
                  } else {
                    this.$router.push({path: item.link, query: { '':this.moveCnt, 'ordNo':item.ordNo }})
                  }

                }
              }
          ).catch((error) => console.log(error))
    },
    updateAllRead(){
      admin_mbrMbrNotiSendHist.updateMbrNotiSendHistAllRead(new FormData())
          .then((response) => {
                if( response.data.statusCode == 1 ){
                  this.messageCnt = 0;
                  this.toastsBottom = [];
                  this.getList();
                }
              }
          ).catch((error) => console.log(error))
    },
    searchProduct:function(){
      let searchData = {
          productCl : "",
          ntslYnNm : "",
          searchKey : "productNm",
          searchValue : this.productNm,
      }
      this.$store.state.pushSearchData = searchData;
      this.$store.state.pushSearchData.beforePage = "header"
      this.moveCnt++;

      this.$router.push({path: "/product/prdMng", query: { '':this.moveCnt }})
    },
    normalizePath:function(path) {
      return decodeURI(path)
        .replace(/#.*$/, '')
        .replace(/(index)?\.(html)$/, '')
    },
    isActiveLinkGroup:function(items) {
      for (let i = 0; i < items.length; i++) {
        const subitem = items[i];
        if(this.isActiveLink(subitem.to)) {
          return true;
        }
      }
      return false;
    },
    isActiveLink:function(link) {

      if (link === undefined) {
        return false
      }

      if (this.route.hash === link) {
        return true
      }

      const currentPath = this.normalizePath(this.route.path)
      const targetPath = this.normalizePath(link)

      return currentPath === targetPath
    },
    logout() {
      store.commit("SET_USER_DATA", null);
      location.href="/login";
      //this.$router.push('/login');
      //localStorage.setItem('token', null);
    },
    myInfo() {
      this.$router.push('/info/myInfo');
    },
    viewMessage(){
      this.changeTabPaneActiveKey(1);
      this.visibleEnd = true;
    },
    // 알림전송 내역 조회
    getList: function(pageNum){
      if( fnToInt(pageNum) != 0 ){
        this.page = fnToInt(pageNum);
      }
      let params = {
        page : this.page,
        pageSize: this.pageSize,
        notiSe: 'MGNS1103',
        orderKey : this.orderKey,
        direction : this.direction,
      }

      if(this.tabPaneActiveKey == 1) {
        params.mbrSn = this.$store.state.mbrSn;
        params.cn = this.searchCn.trim();
      }
      else if(this.tabPaneActiveKey == 2) {
        params.alarmMbrSn = this.$store.state.mbrSn;
      }

        mbrMbrNotiSendHist.listMbrNotiSendHist({params:params})
            .then(
                (response) => {
                  if (response.data.statusCode == 1) {
                    this.listItems = response.data.data.content;
                    this.pageable = {
                      totalElements: response.data.data.totalElements,
                      totalPages: response.data.data.totalPages
                    };
                  }
                }
            )
            .catch((error) => {
              console.log(error);
            })
    },
    getNotReadList: function(){
      let params = {
        page : 1,
        pageSize: this.pageSize,
        notiSe: 'MGNS1103',
        mbrSn : this.$store.state.mbrSn,
        notiRcptnYn : '1', //전송중
        orderKey : this.orderKey,
        direction : this.direction,
      }

      mbrMbrNotiSendHist.listMbrNotiSendHist({params:params})
          .then(
              (response) => {
                if (response.data.statusCode == 1) {
                  let notReadListItems = response.data.data.content;
                  for (let i = 0; i < notReadListItems.length; i++) {
                    let item = notReadListItems[i];

                    if(item.cn.length > 130) item.cn = item.cn.substring(0,130);

                    const pushMsg = {
                      title: item.sj,
                      body: item.cn,
                      link : item.url,
                      mclCd : item.mclCd,
                      ordNo :item.ordNo,
                      icon : '/trophylab_logo.png',
                      reqDt: this.$filters.getStrDateTime(item.alarmDt),
                      visible : true,
                      mbrNotiSn : item.mbrNotiSn,
                    }
                    this.toastsBottom.push(pushMsg)
                  }

                  this.messageCnt = response.data.data.totalElements;
                }
              }
          )
          .catch((error) => {
            console.log(error);
          })
    },
    getMgrList: function(){
      mgrInfoApi.listMgrInfo( {
        params : {
          page:1,
          pageSize:99,
          aprvYn:'1',
          orderKey : "author_group_nm",
          direction : "asc",
        }
      })
          .then(
              (response) => {
                this.mgrListItems = response.data.data.content;
              })
          .catch((error) => console.log(error))
    },
    getNotiRcptnYnNm : function (notiRcptnYn) {
      let notiRcptnYnNm = '';
      switch (notiRcptnYn) {
        case '0':
          notiRcptnYnNm = '전송';
          break;
        case '1':
          notiRcptnYnNm = '전송';
          break;
        case '2':
          notiRcptnYnNm = '전송';
          break;
        case '3':
          notiRcptnYnNm = '확인';
          break;
        case '4':
          notiRcptnYnNm = '전송실패';
          break;
      }
      return notiRcptnYnNm;
    },
    setBookmark:function (){
      mgrMgrInfoApi.getMgrInfo({params: {
          mbrSn: this.$store.state.mbrSn
        }})
        .then((response) => {
          const detailData = response.data.data;

          if(detailData.dtlInfo != null) {
            let dtlInfo = JSON.parse(detailData.dtlInfo)
            if(dtlInfo.bookmark != undefined && dtlInfo.bookmark != null && dtlInfo.bookmark.length > 0) {
              this.bookmarkItems = dtlInfo.bookmark
            }
          }

        })
        .catch((error) => console.log(error))
    }
  },
  created() {
    // this.messageCnt++;
    this.getMgrList();
    this.getNotReadList(); //안읽은 알림 체크
    this.setBookmark();
    // console.log(this.$store.state.mbrInfo.dtlInfo);
    //
    // if(this.$store.state.mbrInfo.dtlInfo != undefined
    // && this.$store.state.mbrInfo.dtlInfo.bookmark.length > 0) {
    //   this.bookmarkItems = this.$store.state.mbrInfo.dtlInfo.bookmark
    // } else {
    //   this.bookmarkItems = [
    //     {
    //       "name": "일정관리",
    //       "to": "/work/scheduleMng",
    //     },
    //     {
    //       "name": "주문접수",
    //       "to": "/order/manageOrd",
    //     }
    //   ]
    // }
    // console.log(this.bookmarkItems)
  },
  mounted() {
    //#1. 웹 워커 등록
    navigator.serviceWorker
      .register("/sw.js")
      .then(function (registration) {
        // console.log("Service worker successfully registered.");
        return registration;
      })
      .catch(function (err) {
        console.error("Unable to register service worker.", err);
      });

    //#2. 파이어베이스 접속
    const app = initializeApp(this.$store.state.firebaseConfig);
    // eslint-disable-next-line no-unused-vars
    const messaging = getMessaging(app);
    // messaging.usePublicVapidKey('BO9JacucSzqV_TczSMKtNUE9kQ6H_qCYz5thHbhU0L_SIBq8_5QHDKiocPbPFslfgn5VxCWQU2Fjv0nKvvPs6oM');

    //#3. 파이어베이스 메시징 기능 사용 적용
    onMessage(messaging, (payload) => {
      // console.log('Message received. ', payload);
      let notificationPermission = Notification.permission;
      if (notificationPermission === "granted" && payload.data != null) {
        //Notification을 이미 허용한 사람들에게 보여주는 알람창
        // console.log(payload);

        const msg = payload.data.msg.split(",");
        const mclCd = msg[0];
        const ordNo = msg[1];
        const mbrNotiSn = msg[2];

        const pushMsg = {
            title: payload.data.title,
            body: payload.data.body,
            link : payload.data.link,
            mclCd : mclCd,
            ordNo : ordNo,
            icon : '/trophylab_logo.png',
            reqDt: this.$filters.getStrDateTime(new Date()),
            visible : true,
            mbrNotiSn : mbrNotiSn,
        }

        if(mclCd == "MGMC0851") {
            this.toasts.push(pushMsg)
        } else {
            this.toastsBottom.push(pushMsg)
        }
        this.messageCnt = this.messageCnt + 1;

        // alert(payload.data.body);
        // navigator.serviceWorker.ready
        //     .then((registration) => {
        //       registration
        //           .showNotification(payload.notification.title, {
        //             body: payload.notification.body,
        //             icon: '/trophylab_logo.png',
        //           });
        //     })
        //     .catch((err) => {
        //       console.log(err);
        //     });

      } else if (notificationPermission !== 'denied') {
        //Notification을 거부했을 경우 재 허용 창 띄우기
        Notification.requestPermission(function (permission) {
          if (permission === "granted") {
            new Notification(payload.data.body, {
              icon: '/trophylab_logo.png',
            });
          } else {
            alert("알람 허용이 거부되었습니다.")
          }
        });
      }
    });

    //#4. 브라우저 백그라운드 진입시 사용할 파일 적용
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        // eslint-disable-next-line no-unused-vars
        .then(function (registration) {
          // console.log("ServiceWorker registration successful with scope: ");
        });
    }
  },
  beforeMount() {
    this.columnDefs = [
      { headerName: 'No'				, width: 50			, colId: 0		, cellStyle : {"justify-content":"center"}
        , valueGetter: (params) => { return this.$filters.setCurrencyComma(this.pageable.totalElements - params.node.rowIndex - ((this.page-1) * (this.pageSize))) }
        , sortable: true },
      { headerName: ((this.tabPaneActiveKey==1)?"보낸이":"받는이")			, width: 70		, cellStyle : {"justify-content":"center"}
        , valueGetter: (params) => {
          if(this.tabPaneActiveKey==1) {
            if(params.node.data.alarmMbrNm != null) {
              // console.log(params.node.data.alarmMbrNm);
              return params.node.data.alarmMbrNm;
            }
            else {
              // console.log(params.node.data.coNm);
              return params.node.data.custNm + ((params.node.data.coNm=='')?'':'('+params.node.data.coNm+')');
            }
          } else {
            return params.node.data.mbrNm
          }
        }
      },
      { headerName: "내용"		, flex : 1			, field: "cn", tooltipField: 'cn'
        , valueGetter: (params) => { return '['+params.node.data.sj+'] '+params.node.data.cn }
      },
      { headerName: "날짜"	, width: 80			, field: "alarmDt"		, cellStyle : {"text-align":"center"}
        , valueGetter: (params) => { return this.$filters.getStrDate2(params.node.data.alarmDt) }
      },
      { headerName: "결과"			, width: 60			, field: "notiRcptnYn"		, cellStyle : {"text-align":"center"}
        , valueGetter: (params) => {
          return this.getNotiRcptnYnNm(params.node.data.notiRcptnYn);
        }
      },
    ];
  },
}
</script>
